var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNotifcationStreak = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8,11c0-0.2,0-0.4-0.2-0.6s-0.4-0.2-0.6-0.1c-1.7,0.8-2.9,2.2-3.6,3.4C21,11.5,19.7,9.4,19,8.4c-0.4-0.6-0.6-1.1-0.7-1.6 c-0.3-2.3,1-5.3,1-5.4c0.1-0.2,0-0.5-0.1-0.6s-0.4-0.2-0.6-0.1C11.5,3.8,8,8.2,8.2,14.1c-0.5-1.3-0.8-2.9-0.9-3.6 c0-0.3-0.2-0.5-0.5-0.5C6.6,9.9,6.3,10,6.2,10.2C4,15.2,3.6,19.5,5.1,23c1.8,4.3,5.9,5.8,6,5.9c0.2,0.1,0.5,0,0.6-0.2 c0.1-0.2,0.2-0.4,0.1-0.6c0,0-2.1-4-0.3-6.9c0.7-1.2,1.3-2,1.7-2.6c1-1.4,1.6-2.2,2.1-4.9c2.8,4.5,0.6,10.4,0.6,10.4 c-0.1,0.2,0,0.4,0.1,0.6c0.1,0.2,0.3,0.2,0.5,0.2c1.1-0.2,1.9-1.7,2.4-2.8c0.6,1,0.8,1.9,0.7,2.8c-0.2,2.1-2.1,3.5-2.1,3.5 c-0.2,0.2-0.3,0.5-0.2,0.7c0.1,0.2,0.3,0.3,0.5,0.3c0.1,0,0.1,0,0.2,0c8.2-3,7.2-11,7.2-11C25,15,25.8,11.1,25.8,11L25.8,11z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotifcationStreak, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Notifcation_Streak.287036ba.svg";
export { ForwardRef as ReactComponent };